import { request } from '@/shared/api/request'

export const createCompany = (params, data) => {
	return request({ url: '/user/save/company', method: 'POST', data, params })
}
